import React, { forwardRef } from "react";
import { REACT_APP_CHILD_URL } from "../../services/constant";

const Modal = forwardRef((props, ref) => {
  return (
    <div className="fixed md:p-[20px] inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="bg-white dark:bg-gray-900 md:rounded-lg overflow-hidden shadow-lg w-full max-w-3xl relative md:max-w-[430px] h-full md:max-h-[800px]">
        <iframe
          ref={ref}
          id="react-app-iframe"
          className="iframe-modal-active w-full h-full"
          src={REACT_APP_CHILD_URL}
          title="React App Iframe"
        ></iframe>
      </div>
    </div>
  );
});

export default Modal;
